export const SHOW_FEATURED_BOOKS = 'bookStore/showFeaturedBooks';
export const SHOW_ALL_BOOKS = 'bookStore/showAllBooks';
export const EDIT_BOOK = 'bookStore/editBook';
export const UPDATE_EDIT_INFO = 'bookStore/updateEditInfo';
export const UPDATE_SEARCH_TEXT = 'bookStore/updateSearchText';
